/* @sravni/react-design-system version 0.2.71 */
var css = "._1766eyx {\n  position: relative;\n  width: 100%;\n}\n._11de650 {\n  position: absolute;\n  right: 16px;\n  bottom: -7px;\n  left: 16px;\n}\n";
var modules_4fe38840 = {"container":"_1766eyx","slider":"_11de650"};
import "../../../assets/components/SliderInput/src/SliderInput-0dea24bf.css";

export default modules_4fe38840;
export { css };
